export const graphqlEndpoint =
  process.env.NODE_ENV === "production"
    ? "https://api.operationalClarity.io/query"
    : "http://localhost:8080/query";

export const apiBaseUrl =
  process.env.NODE_ENV === "production"
    ? "https://api.operationalClarity.io"
    : "http://localhost:8080";

export const isProd = process.env.NODE_ENV === "production";
export const fixedDevTime = 1743372000;